<cpd-dialog-container
  [dialogTitle]="'Career Path DECIDE team'"
  [isCloseIconVisible]="true"
>
  <section class="grid-y grid-margin-y-bottom">
    <div class="cell">
      <img alt="" class="image" src="/assets/images/common/team.jpg" />
    </div>
  </section>
</cpd-dialog-container>
